import { render, staticRenderFns } from "./UserWalletCard.vue?vue&type=template&id=7c71b95f&scoped=true&"
import script from "./UserWalletCard.vue?vue&type=script&lang=js&"
export * from "./UserWalletCard.vue?vue&type=script&lang=js&"
import style0 from "./UserWalletCard.vue?vue&type=style&index=0&id=7c71b95f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71b95f",
  null
  
)

export default component.exports